import { useState } from "react";
import { ProjectModalProps } from "../../data-models/props";
import { DataService } from "../../services/data-service";
import { useStoreActions, useStoreState } from "../../store/data-store";
import ColourSwatch from "../colour-swatch/colour-swatch";

const StartProjectModal = ({ closeModal, project }: ProjectModalProps) => {

    const inventory = useStoreState(store => store.inventory);
    const [firstLoad, setFirstLoad] = useState(true);
    const [threads, setThreads] = useState(project.threads.map(x => x.assignedMeters));

    const user = useStoreState(store => store.user);
    const setInventory = useStoreActions( store => store.setInventory);

    
    if (firstLoad) {
        console.log("SETTING METERS");
        project.threads.forEach((t,idx) => {
            const unassignedInventory = getUnassignedInventory(t.colourNumber);
            threads[idx] = Math.min(t.meters, unassignedInventory);
        });
        setFirstLoad(false);
    }

    const startProject = () => {
        async function startProjectAsync() {
            project.threads.forEach((t,idx) =>{
                t.assignedMeters = threads[idx]
            })
            const dataService = new DataService();
            const tokens = await dataService.getAccessToken(user);
            await dataService.startProject(user.id, tokens.accessToken, project);

            const inventory = await dataService.getInventory(user.id, tokens.accessToken);
            setInventory(inventory);

            closeModal();

        }
        startProjectAsync();
    }

    function handleAssignedMetersChange(index: number, assignedMeters: number) {
        const newArray = [...threads];
        newArray[index] = assignedMeters;
        setThreads(newArray);
    }


    function getUnassignedInventory(colourNumber:string){
        const inventoryColour = inventory.find(x => x.colourNumber === colourNumber);
        var unassignedInventory = 0;
        if (inventoryColour) {
            if (inventoryColour.assignedMeters) {
                unassignedInventory = inventoryColour.meters - inventoryColour.assignedMeters;
            }
            else {
                unassignedInventory = inventoryColour.meters;
            }
        }
        return unassignedInventory;
    }


    return (
        <div className="modal-container">
            <div className="overlay" onClick={closeModal} />
            <div className='modal'>
                <div className="user-input-data">
                    <h2>Start Project</h2>
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th className="col-colour-number">Colour #</th>
                                    <th className="col-meters">Req'd m</th>
                                    <th className="col-meters">Assgn'd m</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    project.threads.map((t, idx) => {
                                        const unassignedInventory = getUnassignedInventory(t.colourNumber);
                                        return (
                                            <tr key={idx}>
                                                <td className="meters-input">{t.colourNumber}</td>
                                                <td className="meters-input">{t.meters}</td>
                                                <td><input className="form-input meters-input" type="number" min="0" max={unassignedInventory} onChange={(e) => handleAssignedMetersChange(idx, Number(e.target.value))} value={threads[idx]} /></td>
                                                <td><ColourSwatch colourNumber={t.colourNumber} /></td>
                                                <td>({unassignedInventory})</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="modal-actions">
                    <button className="small-button" onClick={closeModal} >Cancel</button>
                    <button className='small-button' onClick={startProject} >Start</button>
                </div>

            </div>
        </div>
    )

}

export default StartProjectModal;